import {Invoice, IridiumCollectorDbReader, PaymentMessages} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public Invoice: Invoice,
    public IridiumCollectorDbReader: IridiumCollectorDbReader,
    public PaymentMessages: PaymentMessages,
  ) {}
}